<template>
    <main class="row content__page">
      <section class="column large-full entry format-standard">
        <div class="content__page-header">
          <h1>
            {{ $t('verification.title') }}
          </h1>
        </div>
  
        <div v-if="status === 'verifying'" class="text-center">
          <p>{{ $t('verification.verifying') }}</p>
          <el-skeleton animated :rows="2" />
        </div>
  
        <div v-else-if="status === 'success'">
          <el-result
            icon="success"
            :title="$t('verification.success_title')"
            :sub-title="$t('verification.success_message')"
          >
            <template #extra>
              <el-button type="secondary" @click="$router.push({ name: 'HomePage' })">
                {{ $t('buttons.back_to_home') }}
              </el-button>
            </template>
          </el-result>
        </div>
  
        <div v-else>
          <el-result
            icon="error"
            :title="$t('verification.error_title')"
            :sub-title="$t('verification.error_message')"
          >
            <template #extra>
              <el-button type="secondary" @click="$router.push({ name: 'HomePage' })">
                {{ $t('buttons.back_to_home') }}
              </el-button>
            </template>
          </el-result>
        </div>
      </section>
    </main>
  </template>
  
  <script>
  import { onMounted, ref } from 'vue';
  import { useRoute } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import { VERIFY_NEWSLETTER_SUBSCRIPTION_EMAIL } from '@/graphql/newsletter-subscriptions';
  import apolloClient from '@/services/apollo-client';
  import { ElNotification } from 'element-plus';
  
  export default {
    name: 'VerifyEmailPage',
    setup() {
      const route = useRoute();
      const { t } = useI18n();
      const token = ref(route.params.verification_token);
      const status = ref('verifying');
  
      const verify = async () => {
        try {
          const { data } = await apolloClient.mutate({
            mutation: VERIFY_NEWSLETTER_SUBSCRIPTION_EMAIL,
            variables: { 
                token: token.value,
                send_thank_you_email: true
             }
          });
  
          if (data?.verifyNewsletterSubscriptionEmail?.success) {
            status.value = 'success';
          } else {
            status.value = 'error';
          }
        } catch (err) {
          status.value = 'error';
          ElNotification({
            title: t('notifications.error.title'),
            message: err.message || t('verification.error_message'),
            type: 'error'
          });
        }
      };
  
      onMounted(verify);
  
      return {
        t,
        status
      };
    }
  };
  </script>
  
<style scoped>
  .text-center {
    text-align: center;
    margin-top: 40px;
  }

  ::v-deep(.el-result__icon svg) {
    color: black; /* or any color you want */
}
</style>
  